// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--3SmJE","logoImage":"logo-module--logo-image--2fgin"};